import { useModalHook } from '@/components/commons/modals/useModalHook';
import {
  addModalOpenRecoil,
  addModalTitleRecoil,
  environmentRecoil,
  syncLoadingRecoil,
} from '@/recoil/atoms/MobileRecoil/MobileRecoil';
import { detectEnvUtils } from '@/shared/util/detectEnvUtils';
import IconAddAddressGroup from '@/styles/icons/IconAddAddressGroup';
import IconAddressSync from '@/styles/icons/IconAddressSync';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // useNavigate import 추가
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import * as S from '../MobileHeader.style';
import { userInfoRecoil } from '@/recoil/atoms/useInfo';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { postAddMobileGroup } from '@/apis/api/addressApis';

const AddressGroupListHeader = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { customSuccessModal, customWarningModal, confirmModal, warningModal } = useModalHook();
  const setSyncLoadingS = useSetRecoilState(syncLoadingRecoil);
  // 추가 방 상태 리코일
  const setAddModalOpenS = useSetRecoilState(addModalOpenRecoil);
  // 추가 방 제목 리코일
  const setAddModalTitleS = useSetRecoilState(addModalTitleRecoil);
  //모바일 주소록 동기화 시킬때 로딩창
  const [syncLoading, setSyncLoading] = useRecoilState(syncLoadingRecoil);

  const { mutate: addGroupMutate } = useMutation(postAddMobileGroup, {
    onMutate: () => {
      setSyncLoading({ state: true, contents: '모바일 기기에서 주소록을 동기화 중입니다.' });
    },
    onSuccess: () => {
      customSuccessModal(
        () => {
          setSyncLoading({ state: false, contents: '' });
          queryClient.refetchQueries(['groupList2']);
        },
        '성공',
        '주소록 정보가 동기화 되었습니다.',
        true,
      );
    },
    onError: (error) => {
      customWarningModal(
        () => {
          setSyncLoading({ state: false, contents: '' });
        },
        '실패',
        `주소록 정보 동기화에 실패 했습니다.(주소록에서 모바일 주소록 동기화를 다시 한번 진행해 주세요): ${error}`,
        true,
      );
    },
    onSettled: () => {
      navigate('/mobile/address/groupList');
    },
  });

  // 그룹 추가 버튼 눌렀을 때 동작하는 함수
  const onClickAddModalOpen = () => {
    setAddModalOpenS(true);
    setAddModalTitleS('그룹 추가');
    window.location.hash = '#add';
  };

  // 주소록 동기화 클릭 했을 때 동작하는 함수
  const onClickMobileAddressAdd = () => {
    if (detectEnvUtils() === 'app') {
      try {
        confirmModal(
          () => {
            setSyncLoadingS({ state: true, contents: '모바일 기기에서 연락처를 불러오는 중입니다' });
            window.fromWebToAppReqAddressList(localStorage.getItem('callBack') ?? '');
          },
          '주소록 동기화',
          '연락처 정보를 동기화하면 사용자의 연락처가 서버에 업로드됩니다.</br>이 데이터는 문자 전송 및 연락처 관리 기능을 제공하는 데에만 사용됩니다.</br></br>개인정보 보호를 위해, 사용자의 연락처 데이터는 암호화되어 저장되며 제3자와 공유되지 않습니다.</br></br>동기화를 진행하시겠습니까?',
          true,
          undefined,
          () => {
            warningModal('동기화 실패', '주소록에서 동기화를 다시 시도할 수 있습니다.', true);
          },
        );
      } catch {
        warningModal('동기화 실패', '주소록에서 동기화를 다시 시도할 수 있습니다.', true);
      }
    } else {
      warningModal('실패', "주소록 동기화 기능은 '톡비서' 앱에서 이용 가능 합니다.", true);
    }
  };

  // 주소록 동기화
  useEffect(() => {
    window.autoAddressSync = (userID, addressList, id) => {
      if (id === 'true') {
        type TAddress = { name: string; phone: string };

        const parseAddressList: TAddress[] = JSON.parse(addressList).filter(
          (item: any): item is TAddress => typeof item.phone === 'string' && typeof item.name === 'string',
        );

        type TPayload = {
          contacts: { buddyNm: string; keyCommNo: string }[];
        };

        // 이름은 필수가 아님 - 번호는 필수값
        const payload: TPayload = {
          contacts: parseAddressList.map((item: TAddress) => ({
            buddyNm: item.name !== '' ? item.name : `이름없음${item.phone}`,
            keyCommNo: item.phone.replace(/\D/g, ''), // 전화번호에서 숫자만 추출
          })),
        };
        setSyncLoading({ state: false, contents: '' });
        addGroupMutate(payload);
      } else {
        customWarningModal(
          () => {
            setSyncLoading({ state: false, contents: '' });
          },
          '실패',
          '주소록 권한을 확인 해주세요.',
          true,
        );
      }
    };
  }, []);

  return (
    <>
      <S.IconContainer>
        {/* 폴더 추가 아이콘 */}
        <S.HeaderRightButtonIcon
          onClick={() => {
            onClickAddModalOpen();
          }}
        >
          <IconAddAddressGroup />
        </S.HeaderRightButtonIcon>

        {/* 주소록 동기화 아이콘 */}
        <S.HeaderRightButtonIcon
          onClick={() => {
            onClickMobileAddressAdd();
          }}
        >
          <IconAddressSync />
        </S.HeaderRightButtonIcon>

        {/* 설정 아이콘 */}
        {/* <S.HeaderRightButtonIcon>
          <TbSettings style={{ strokeWidth: 1.5 }} />
        </S.HeaderRightButtonIcon> */}
      </S.IconContainer>
    </>
  );
};

export default AddressGroupListHeader;
